/* global gtag */

// Simple analytics utility
const trackEvent = (eventName, eventData = {}) => {
  console.log(`📊 [Analytics] ${eventName}:`, eventData);
  
  // 🆕 Send to Google Analytics
  if (typeof gtag !== 'undefined') {
    gtag('event', eventName, eventData);
  }
  
  // Save to localStorage for later analysis
  const events = JSON.parse(localStorage.getItem('shadiArtsAnalytics') || '[]');
  events.push({
    name: eventName,
    data: eventData,
    timestamp: new Date().toISOString(),
    url: window.location.href,
    referrer: document.referrer
  });
  
  // Keep only last 100 events
  if (events.length > 100) events.shift();
  localStorage.setItem('shadiArtsAnalytics', JSON.stringify(events));
};

const trackPageView = (pageName) => {
  trackEvent('page_view', { page: pageName });
  
  // 🆕 Send page view to Google Analytics
  if (typeof gtag !== 'undefined') {
    gtag('config', 'G-23L1S0LXJ0', { page_path: window.location.pathname });
  }
};

const trackOrder = (orderData) => {
  trackEvent('order_created', {
    portraitType: orderData.portraitType,
    price: orderData.estimatedPrice,
    hasPhotos: orderData.referencePhotos?.length > 0
  });
};

export { trackEvent, trackPageView, trackOrder };